/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
// import { imgBase64 } from "../imgBase64/ImgBase64";
import {imgBase64} from '../../../../app/utils/imgBase64/ImgBase64'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import useFetch from '../../../../app/hooks/useFetch'
import useModuleStructure from '../../../../app/hooks/useModuleStructure'

export function AsideMenuMain() {
  const intl = useIntl()
  const isDev = window.location.hostname.includes('localhost') || window.location.hostname.includes('dev-net.goplicity')

  const {renderModules} = useModuleStructure()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/nuevos/casa.svg'
        title='Inicio'
        fontIcon=''
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menú</span>
        </div>
      </div>
      {renderModules()}

      {isDev && (
        <>
          <div className='menu-item'>
            <div className='menu-content'>
              <div className='separator mx-1 my-4'></div>
            </div>
          </div>
          <div className='menu-item'>
            <div className='menu-content pt-0 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Develop</span>
            </div>
          </div>
          <AsideMenuItemWithSub
            to='/crafted/pages'
            title='Demo Minutas'
            fontIcon='bi-archive'
            icon='bi-bar-chart'
          >
            <AsideMenuItem to='/minuta' title='Detalle Minuta B' hasBullet={true} />
            <AsideMenuItem to='/minutaC' title='Detalle Minuta C' hasBullet={true} />
          </AsideMenuItemWithSub>

          <AsideMenuItemWithSub
            to='/crafted/pages'
            title='Demo Mantenedores'
            fontIcon='bi-archive'
            icon='bi-bar-chart'
          >
            <AsideMenuItem to='/Maintainer' title='Mantenedor' hasBullet={true} />
            <AsideMenuItem
              to='/mantenedor-tramo-costo'
              title='Mantenedor Tramo Costo'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-centro-costo'
              title='Mantenedor centro costo'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-tramo-costo-ceco'
              title='Mantenedor centro costo Ceco'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-sitio-sellos'
              title='Mantenedor Sitios Sellos'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-tramo-complejidad'
              title='Mantenedor Tramo Complejidad'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-porcentaje-color'
              title='Mantenedor Porcentaje Color'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-cruce-ingredientes'
              title='Mantenedor Cruce Ingredientes'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-calendario-tope'
              title='Mantenedor Calendario Tope'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/mantenedor-roles-usuarios'
              title='Mantenedor Roles'
              hasBullet={true}
            />
            <AsideMenuItem to='/mantenedor-usuario' title='Mantenedor Usuario' hasBullet={true} />
            <AsideMenuItem to='/mantenedor-modulos' title='Mantenedor Modulos' hasBullet={true} />
            <AsideMenuItem
              to='/mantenedor-modulo-rol'
              title='Mantenedor Modulos Rol'
              hasBullet={true}
            />
          </AsideMenuItemWithSub>

          <AsideMenuItemWithSub
            to='/crafted/pages'
            title='Grilla'
            fontIcon='bi-archive'
            icon='bi-bar-chart'
          >
            <AsideMenuItem to='/grilla1' title='Grilla 1' hasBullet={true} />
            <AsideMenuItem to='/minutas/minutaFood' title='Minuta Food' hasBullet={true} />
            <AsideMenuItem to='/BulkLoad' title='Carga Masiva' hasBullet={true} />
            <AsideMenuItem to='/minutaVertical' title='Minuta Vertical' hasBullet={true} />
            <AsideMenuItem to='/minutaHorizontal' title='Minuta Horizontal' hasBullet={true} />
          </AsideMenuItemWithSub>

          <AsideMenuItemWithSub
            to='/crafted/widgets'
            title='Widgets'
            icon='bi-grid'
            fontIcon='bi-layers'
          >
            <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
          </AsideMenuItemWithSub>
        </>
      )}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div> */}
      {/* <AsideMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </AsideMenuItemWithSub> */}
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>

      <div className='menu-item' style={{position: 'relative', bottom: '3px'}}>
        <a target='_blank' className='menu-link'>
          <span className='menu-icon'>
            <KTSVG path='/media/icons/nuevos/version.svg' className='svg-icon-2' />
          </span>
          <span className='aside-title'>Versión {process.env.REACT_APP_VERSION}</span>
        </a>
      </div>
    </>
  )
}
